import client from "../client";

export const registrationsApi = {
    /**
     * Mirrors the legacy `POST /api/register` contract.
     * @param {{childData: object, familyData: object}} payload
     */
    async create(payload) {
        const { data } = await client.post("/register", payload);
        return data;
    },
};
